import React, { useState } from "react";
import { PageTopbar } from "../../../components/Page/Topbar";
import { PageHeader } from "../../../components/Page/Header";
import { AppArticlesDepotRequest } from "../../../app/Articles/Depot/Request";

export function RoutesArticlesDepotRequest({ title, parents, current }) {

    let identifier = (parents + current).replaceAll('/', '-');

    return (
        <div>
            <PageTopbar
                parents={parents}
                current={current}
            />

            {/* <Identity /> */}

            <PageHeader
                title={title}
                parents={parents}
                current={current}
                identifier={identifier}
            />

            <AppArticlesDepotRequest
                parents={parents}
                current={current}
            />
        </div>
    );
}